import React from 'react'
import FilterButton from './FilterButton';
import OptionButton from './OptionButton';


export default function SearchPanelFilterJICE(props) {
    const anchorRef = React.useRef(null);
    
    function getDisabled(type){
        //未選択
        if(props.filters.type.length === 0){
            return false;
        }else{
            
            var isPhoto = props.filters.type.includes("photo");
            var isOther = props.filters.type.some((item) => item !== "photo")

            //撮影日時
            if(type === "filmingDateTime"){
                return !isPhoto;
            }else
            //その他
            {
                return !isOther;
            }
        }
    }

    return (
        <div className={"searchpanel-collapsed " + (props.searchPanelVisible ? "searchpanel-visible" : "")}>
                        
            <div ref={anchorRef} className="searchpopupshow" />

            <div className="searchfilters">
                <FilterButton label="区間表示単位"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onApplyFilter={props.onApplyFilter}
                    onClick={props.onSearchFilterClick}
                    
                    isDisabled={getDisabled("pavementLength")}
                    isShow={!getDisabled("pavementLength") || props.filters.pavementLength.length !== 0}

                    popupKind={'radio'}
                    filterKind={'pavementLength'}
                    targetType={props.filters.pavementLength}
                />

                <FilterButton label={"管理事務所"}
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onApplyFilter={props.onApplyFilter}
                    onClick={props.onSearchFilterClick}

                    isDisabled={getDisabled("componentManagerOffice")}
                    isShow={!getDisabled("componentManagerOffice") || props.filters.componentManagerOffice.length !== 0}

                    popupKind={'list'}
                    filterKind={'componentManagerOffice'}
                    targetTypes={props.filters.componentManagerOffice}
            />

                <FilterButton label="健全性"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onApplyFilter={props.onApplyFilter}
                    onClick={props.onSearchFilterClick}
                    
                    isDisabled={getDisabled("overallHealthLevel")}
                    isShow={!getDisabled("overallHealthLevel") || props.filters.overallHealthLevel.length !== 0}

                    popupKind={'list'}
                    filterKind={'overallHealthLevel'}
                    targetTypes={props.filters.overallHealthLevel}
                />
                
                <FilterButton label={"上下線"}
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onClick={props.onSearchFilterClick}
                    onApplyFilter={props.onApplyFilter}
                    
                    isDisabled={getDisabled("roadBoard")}
                    isShow={!getDisabled("roadBoard") || props.filters.roadBoard.length !== 0}

                    popupKind={'list'}
                    filterKind={'roadBoard'}
                    targetTypes={props.filters.roadBoard}
                />

                <OptionButton label="オプション" onClick={props.onSearchOptionClick} />
            </div>
        </div>
    );

}
